import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "d-flex flex-column w-100",
  style: {"position":"relative","overflow":"hidden"}
}
const _hoisted_2 = {
  key: 0,
  class: "rounded-2 d-flex align-items-center justify-content-center gap-2",
  style: {"position":"absolute","top":"0","left":"0","z-index":"1","background-color":"var(--cor_background_2)","width":"100%","height":"193.35px"},
  role: "status"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border",
  style: {"color":"var(--cor_texto_1)"},
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"var(--cor_texto_1)"} }, " Carregando... ", -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = ["src", "type"]
const _hoisted_7 = ["src", "type"]
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "row g-4 mt-1" }
const _hoisted_12 = { class: "col-sm-6" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  for: "form-training-post-url",
  class: "btn btn-sm background_btn_1_opct w-100"
}, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "fa fa-upload",
    "aria-hidden": "true"
  }),
  /*#__PURE__*/_createTextVNode(" Subir mídia ")
], -1)
const _hoisted_14 = { class: "col-sm-2" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-eye m-0 p-0",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "col-sm-2" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M19.0853 5.41971C18.8672 4.59853 18.2246 3.95179 17.4088 3.73232C15.9299 3.3335 10 3.3335 10 3.3335C10 3.3335 4.07019 3.3335 2.59133 3.73232C1.77546 3.95183 1.13289 4.59853 0.914805 5.41971C0.518555 6.90815 0.518555 10.0136 0.518555 10.0136C0.518555 10.0136 0.518555 13.1191 0.914805 14.6076C1.13289 15.4287 1.77546 16.0485 2.59133 16.268C4.07019 16.6668 10 16.6668 10 16.6668C10 16.6668 15.9299 16.6668 17.4088 16.268C18.2246 16.0485 18.8672 15.4287 19.0853 14.6076C19.4815 13.1191 19.4815 10.0136 19.4815 10.0136C19.4815 10.0136 19.4815 6.90815 19.0853 5.41971ZM8.06064 12.8332V7.19409L13.0169 10.0137L8.06064 12.8332Z",
    fill: "#ED2B46"
  })
], -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { class: "col-sm-2" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-trash-alt m-0 p-0",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_24 = [
  _hoisted_23
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalYoutubeURL = _resolveComponent("ModalYoutubeURL")!
  const _component_CampModalMediaFromURL = _resolveComponent("CampModalMediaFromURL")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.isLoadingMedia)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "d-flex align-items-center justify-content-center rounded-2",
        style: _normalizeStyle([{"overflow":"hidden","width":"100%","height":"193.35px"}, `opacity: ${ _ctx.isLoadingMedia ? '0' : '1' }`])
      }, [
        (_ctx.mediaFileURL)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_ctx.isVideoMedia && _ctx.numberVideosLoaded % 2 == 0)
                ? (_openBlock(), _createElementBlock("video", {
                    key: 0,
                    onLoadeddata: _cache[0] || (_cache[0] = () => (_ctx.stopLoaderMedia(), _ctx.loaderStore.close())),
                    controls: "",
                    style: {"width":"343px","height":"100%"}
                  }, [
                    _createElementVNode("source", {
                      src: _ctx.mediaFileURL,
                      type: _ctx.mediaFile.contentType
                    }, null, 8, _hoisted_6),
                    _createTextVNode(" Seu navegador não suporta o elemento de vídeo. ")
                  ], 32))
                : _createCommentVNode("", true),
              (_ctx.isVideoMedia && _ctx.numberVideosLoaded % 2 == 1)
                ? (_openBlock(), _createElementBlock("video", {
                    key: 1,
                    onLoadeddata: _cache[1] || (_cache[1] = () => (_ctx.stopLoaderMedia(), _ctx.loaderStore.close())),
                    controls: "",
                    style: {"width":"343px","height":"100%"}
                  }, [
                    _createElementVNode("source", {
                      src: _ctx.mediaFileURL,
                      type: _ctx.mediaFile.contentType
                    }, null, 8, _hoisted_7),
                    _createTextVNode(" Seu navegador não suporta o elemento de vídeo. ")
                  ], 32))
                : _createCommentVNode("", true),
              (_ctx.isImageMedia)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 2,
                    onLoad: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.stopLoaderMedia && _ctx.stopLoaderMedia(...args))),
                    src: _ctx.mediaFileURL,
                    class: "w-100 h-100",
                    style: {"object-fit":"cover"},
                    alt: ""
                  }, null, 40, _hoisted_8))
                : _createCommentVNode("", true),
              (_ctx.isApplicationMedia)
                ? (_openBlock(), _createElementBlock("embed", {
                    key: 3,
                    onLoad: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.stopLoaderMedia && _ctx.stopLoaderMedia(...args))),
                    src: _ctx.mediaFileURL,
                    type: "application/pdf",
                    style: _normalizeStyle(`opacity: ${_ctx.isLoadingMedia ? '0' : '1'}`),
                    class: "w-100 h-100"
                  }, null, 44, _hoisted_9))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.mediaFile.youtubeURL)
          ? (_openBlock(), _createElementBlock("iframe", {
              key: 1,
              onLoad: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.stopLoaderMedia && _ctx.stopLoaderMedia(...args))),
              src: _ctx.mediaFile.youtubeURL,
              title: "YouTube video player",
              frameborder: "0",
              allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
              allowfullscreen: "",
              width: "343px",
              height: "100%"
            }, null, 40, _hoisted_10))
          : _createCommentVNode("", true),
        (!_ctx.mediaFileURL && !_ctx.mediaFile.youtubeURL)
          ? (_openBlock(), _createElementBlock("img", {
              key: 2,
              onLoad: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.stopLoaderMedia && _ctx.stopLoaderMedia(...args))),
              src: "images/undefined-img.png",
              class: "w-100 h-100",
              style: {"object-fit":"cover"},
              alt: "selecione um video"
            }, null, 32))
          : _createCommentVNode("", true)
      ], 4),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("input", {
            type: "file",
            class: "d-none",
            placeholder: "Escolha um video",
            id: "form-training-post-url",
            onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleMediaFileChange && _ctx.handleMediaFileChange(...args)))
          }, null, 32)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.viewModalToggle = !_ctx.viewModalToggle)),
            class: "btn btn-sm background_btn_1_opct w-100 px-0",
            disabled: _ctx.btnEyeDisabled
          }, _hoisted_17, 8, _hoisted_15)
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[8] || (_cache[8] = () => _ctx.youtubeURLModalToggle = !_ctx.youtubeURLModalToggle),
            class: "btn btn-sm background_btn_1_opct btn-custom-youtube w-100 px-0"
          }, _hoisted_20)
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.handleMediaDel && _ctx.handleMediaDel(...args))),
            class: "btn btn-sm background_btn_1_opct w-100 px-0",
            disabled: _ctx.mediaFileURL || _ctx.mediaFile.youtubeURL ? false : true
          }, _hoisted_24, 8, _hoisted_22)
        ])
      ])
    ]),
    _createVNode(_component_ModalYoutubeURL, {
      "onGet:YoutubeURL": _ctx.handleYoutubeURL,
      toggle: _ctx.youtubeURLModalToggle
    }, null, 8, ["onGet:YoutubeURL", "toggle"]),
    (_ctx.mediaFileURL)
      ? (_openBlock(), _createBlock(_component_CampModalMediaFromURL, {
          key: 0,
          uuid: "98ebb885-b98d-443f-948e-f6432ab466c7",
          header: _ctx.mediaFile.file?.name,
          src: _ctx.mediaFileURL,
          "content-type": _ctx.mediaFile.contentType,
          toggle: _ctx.viewModalToggle,
          "modal-fullscreen-list": ['image', 'pdf'],
          "show-btn-fullscreen-list": ['image', 'pdf'],
          "auto-hide-header-list": ['image'],
          "time-auto-hide": 3
        }, null, 8, ["header", "src", "content-type", "toggle"]))
      : _createCommentVNode("", true)
  ], 64))
}